import { TableFieldProperty, TableFieldPropertyTypes } from '@shared/types';
import { calcTableRowCount, useDocumentStore } from '../state/useDocumentStore';
import { useSelectedFieldStore } from '../state/useSelectedFieldStore';
import { isGeneralField } from '../utils/isGeneralField';
import { calculateWeight } from '../utils/calculateWeight';
import { useEffect } from 'react';
export function useUpdateTable() {
    const { updatePage, page, pageId } = useDocumentStore();
    const { field } = useSelectedFieldStore();
    const tableRowCount = calcTableRowCount();
    useEffect(() => {
        if (page) {
            updatePageWithWeight(page);
        }
    }, []);
    function getTableRowData(fieldIndex) {
        if (!page) {
            console.log('Page not found');
            // @ts-ignore
            return {};
        }
        let row = {};
        const tableEntries = Object.entries(page.predictions.table);
        for (let i = 0; i < tableEntries.length; i++) {
            row = Object.assign(Object.assign({}, row), { [tableEntries[i][0]]: {
                    coordinates: [],
                    values: tableEntries[i][1].values[fieldIndex]
                } });
        }
        return row;
    }
    function updateCellValue(newValue, fieldIndex) {
        if (field &&
            !isGeneralField(field) &&
            page.predictions.table[field.property] &&
            page) {
            const propertyToUpdate = field.property;
            if (field.type === TableFieldPropertyTypes.integer &&
                newValue !== null &&
                !newValue.toString().match(/^[0-9]*$/)) {
                return;
            }
            if (field.type === TableFieldPropertyTypes.float &&
                newValue !== null &&
                !newValue.toString().match(/^[0-9]*\.?[0-9]*$/)) {
                return;
            }
            const updatedPage = Object.assign(Object.assign({}, page), { predictions: Object.assign(Object.assign({}, page.predictions), { table: Object.assign(Object.assign({}, page.predictions.table), { [field.property]: {
                            // @ts-ignore
                            coordinates: page.predictions.table[propertyToUpdate].coordinates,
                            values: new Array(tableRowCount).fill(null).map((v, index) => {
                                if (fieldIndex === index) {
                                    return newValue;
                                }
                                else {
                                    // @ts-ignore
                                    const fieldValues = page.predictions.table[propertyToUpdate].values;
                                    if (fieldValues[index]) {
                                        return fieldValues[index];
                                    }
                                    else {
                                        return v;
                                    }
                                }
                            })
                        } }) }) });
            updatePageWithWeight(updatedPage);
        }
    }
    function addNewRow(values) {
        if (page && pageId !== undefined) {
            let table = {};
            const tableEntries = Object.entries(page.predictions.table);
            for (let i = 0; i < tableEntries.length; i++) {
                table = Object.assign(Object.assign({}, table), { [tableEntries[i][0]]: {
                        coordinates: [
                            ...tableEntries[i][1].coordinates,
                            values ? values[tableEntries[i][0]].coordinates : []
                        ],
                        values: [
                            ...tableEntries[i][1].values,
                            values ? values[tableEntries[i][0]].values : null
                        ]
                    } });
            }
            updatePage(Object.assign(Object.assign({}, page), { predictions: Object.assign(Object.assign({}, page.predictions), { table }) }));
        }
    }
    return {
        addNewRow,
        updateCellValue,
        getTableRowData
    };
    function updatePageWithWeight(page) {
        updatePage(Object.assign(Object.assign({}, page), { predictions: Object.assign(Object.assign({}, page.predictions), { table: Object.assign(Object.assign({}, page.predictions.table), { [TableFieldProperty.weight]: {
                        // @ts-ignore
                        coordinates: page.predictions.table[TableFieldProperty.weight].coordinates,
                        values: calculateWeight(page)
                    } }) }) }));
    }
}
